import {
  CHANGE_ORGANIZATIONS_IS_SAVE,
  GET_ORGANIZATIONS,
  CREATE_ORGANIZATIONS_ERROR,
  CREATE_ORGANIZATIONS_NO_ERROR,
  GET_ORGANIZATION,
  RESET_ORGANIZATION,
  SET_SEARCH_PARAMS_ORGANIZATIONS,
} from "../../types";

const initialState = {
  organizations: [],
  organization: {},
  searchParams: {
    name: "",
    shortName: "",
  },
  message: "",
  isSaved: false,
};

export const organizationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORGANIZATIONS:
      // return (() => ({
      //   ...state,
      //   organizations: action.data,
      // }))();
      return {
        ...state,
        organizations: action.data,
      };
    case SET_SEARCH_PARAMS_ORGANIZATIONS:
      return {
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      };
    case RESET_ORGANIZATION:
      return {
        ...state,
        organization: {},
      };
    case GET_ORGANIZATION:
      return {
        ...state,
        organization: state.organizations.find((item) => item.id === Number(action.data)) || {},
      };
    case CREATE_ORGANIZATIONS_NO_ERROR:
      return (() => ({
        ...state,
        message: action.data,
        isSaved: true,
      }))();
    case CREATE_ORGANIZATIONS_ERROR:
      return (() => ({
        ...state,
        message: action.data,
        isSaved: false,
      }))();
    case CHANGE_ORGANIZATIONS_IS_SAVE:
      return (() => ({
        ...state,
        isSaved: false,
        message: "",
      }))();

    default:
      return state;
  }
};
